import React from "react";

const CheckBox = ({ id, name, value, label, error, onChange, checked }) => {
  return (
    <div>
      <label
        htmlFor={`${id}`}
        className="flex flex-row items-center gap-4 cursor-pointer"
      >
        <input
          type="checkbox"
          name={`${name}`}
          id={`${id}`}
          value={`${value}`}
          onChange={onChange}
          checked={checked}
          className="w-4 h-4 p-0 m-0 accent-[#AB3C1B]"
        />
        <span htmlFor={`${id}`}>{label}</span>
      </label>
      <div className="h-2">
        <label
          htmlFor={id}
          className="font-normal text-[0.75rem] text-red-500 bg-white  pt-1 my-0 py-0 font"
        >
          {error}
        </label>
      </div>
    </div>
  );
};

export default CheckBox;
